<h1 class="no-margin-bottom">Masseskift af partner aftaler</h1>
<h2 class="h3 no-margin-top">{{ partner?.name }}</h2>
<button class="btn-close btn-icon" (click)="onCloseClick()" title="Luk">
  <mat-icon svgIcon="remove"></mat-icon>
</button>
<div class="dashboard">
  @if (partner) {
    <div class="dashboard-tile-wrapper">
      <div
        class="dashboard-tile dashboard-tile--enabled"
        [class.dashboard-tile--active]="filter == PartnerChangeFilter.Current"
        (click)="filterAgreements(PartnerChangeFilter.Current)"
        >
        <mat-icon svgIcon="handshake" class="icon-48"></mat-icon>
        <div class="dashboard-tile__data">
          <div class="dashboard-tile__title">Nuværende</div>
          <div class="dashboard-tile__text">
            <span>{{ partner.partnerCustomerCount.numberOfAgreements }} aftale</span>
            @if (partner.partnerCustomerCount.numberOfAgreements != 1) {
              <span>r</span>
            }
          </div>
        </div>
      </div>
      <div
        class="dashboard-tile dashboard-tile--enabled"
        [class.dashboard-tile--active]="filter == PartnerChangeFilter.Future"
        (click)="filterAgreements(PartnerChangeFilter.Future)"
        >
        <mat-icon svgIcon="new" class="icon-48"></mat-icon>
        <div class="dashboard-tile__data">
          <div class="dashboard-tile__title">Kommende</div>
          <div class="dashboard-tile__text">
            <span>{{ partner.partnerCustomerCount.numberOfAgreementsSwitchingToPartnerInTheFuture }} aftale</span>
            @if (partner.partnerCustomerCount.numberOfAgreementsSwitchingToPartnerInTheFuture != 1) {
              <span>r</span>
            }
          </div>
        </div>
      </div>
      <div class="vertical-line"></div>
      <div
        class="dashboard-tile dashboard-tile--enabled"
        [class.dashboard-tile--active]="filter == PartnerChangeFilter.AlreadyChanged"
        (click)="filterAgreements(PartnerChangeFilter.AlreadyChanged)"
        >
        <mat-icon svgIcon="swap" class="icon-48"></mat-icon>
        <div class="dashboard-tile__data">
          <div class="dashboard-tile__title">Skifter til ny s-partner</div>
          <div class="dashboard-tile__text">
            <span>{{ alreadyChangedCount }} aftale</span>
            @if (alreadyChangedCount != 1) {
              <span>r</span>
            }
          </div>
        </div>
      </div>
      <div
        class="dashboard-tile dashboard-tile--enabled"
        [class.dashboard-tile--active]="filter == PartnerChangeFilter.NotChanged"
        (click)="filterAgreements(PartnerChangeFilter.NotChanged)"
        >
        <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
        <div class="dashboard-tile__data">
          <div class="dashboard-tile__title">Mangler skifte</div>
          <div class="dashboard-tile__text">
            <span>{{ notChangedCount }} aftale</span>
            @if (notChangedCount != 1) {
              <span>r</span>
            }
          </div>
        </div>
      </div>
    </div>
  }
  <app-excel
    [DocumentType]="documentType"
    [HandlerType]="handlerType"
    [Filter]="partnerNo.toString()"
    [ShowDownloadCta]="moreAgreementsThanShown ? 'Bemærk listen viser kun de første 150 aftaler' : ''"
  ></app-excel>
</div>

<div class="dashboard__list">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 has-notifications">
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="onCheckAll($event.checked)"></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let serviceaftale">
        <mat-checkbox
          (change)="onServiceaftaleChecked($event.checked, serviceaftale)"
          [checked]="aftalerToBeMoved.has(serviceaftale.okKundeAftaleNr)"
        ></mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="Serviceabonnement.Produkt">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <mat-icon [svgIcon]="getProductIcon(serviceaftale)" [matTooltip]="getProductIcon(serviceaftale) | titlecase"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="kundenr">
      <th mat-header-cell *matHeaderCellDef>Kundenr</th>
      <td mat-cell *matCellDef="let serviceaftale">
        @if (serviceaftale.kunde) {
          <div>{{ serviceaftale.kunde ? serviceaftale.kunde.okKundeNr : '' }}</div>
        }
        @if (!serviceaftale.kunde) {
          <div>
            <span matTooltip="Ingen data i G4">N/A</span>
          </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="kundeNavn">
      <th mat-header-cell *matHeaderCellDef>Navn</th>
      <td mat-cell *matCellDef="let serviceaftale">
        {{ serviceaftale.kunde ? serviceaftale.kunde.anlaegsadresse?.name : 'N/A' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="OkKundeAftaleNr">
      <th mat-header-cell *matHeaderCellDef>Aftalenr</th>
      <td mat-cell *matCellDef="let serviceaftale">{{ serviceaftale.okKundeAftaleNr }}</td>
    </ng-container>
    <ng-container matColumnDef="adresse">
      <th mat-header-cell *matHeaderCellDef>Anlægsadresse</th>
      <td mat-cell *matCellDef="let serviceaftale">
        <div class="truncate" [matTooltip]="concatAdresseLokation(serviceaftale)">
          {{ concatAdresseLokation(serviceaftale) }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="newPartner">
      <th mat-header-cell *matHeaderCellDef>Ny partner</th>
      <td mat-cell *matCellDef="let serviceaftale">
        @if (serviceaftale.upcomingPartner) {
          <span>{{ serviceaftale.upcomingPartner.name }}</span>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="changeDate">
      <th mat-header-cell *matHeaderCellDef>Skift pr</th>
      <td mat-cell *matCellDef="let serviceaftale">
        @if (serviceaftale.upcomingPartner) {
          <span>
            {{ serviceaftale.upcomingPartner.validFrom | date: 'dd.MM.yyyy' }}
          </span>
        }
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
@if (aftalerToBeMoved.size > 0) {
  <div class="save-changes-bar">
    <button (click)="changePartner()" mat-raised-button color="primary">Skift på {{ aftalerToBeMoved.size }} valgte aftaler</button>
  </div>
}
